<template>
  <div class="scanredirect-page">
    <div class="content">
      <van-cell-group class="item-row" >
        <van-cell @click="handleNavigation('help')" v-if="type === ''">

          <div slot="title">
            <div style="display: flex;align-items: center">
              <van-icon name="/static/images/icon/help.svg" />
              <div class="text-content">
                <div class="text-title">{{ $t('append_field.help') }}</div>
                <div class="text-subtitle">{{ $t('append_field.network_import') }} {{ $t('append_field.mobile_mode') }} {{ $t('append_field.standalone_mode') }}</div>
              </div>
            </div>
            <span class="cell-right"> <van-icon name="arrow"/> </span>
          </div>
        </van-cell>
        <van-cell @click="handleNavigation('apk')" >

          <div slot="title">
            <div style="display: flex;align-items: center">
              <van-icon name="/static/images/icon/APK.svg" />
              <div class="text-content">
                <div class="text-title">{{ $t('append_field.apk_download') }}</div>
                <div class="text-subtitle" v-if="type === ''">{{ $t('append_field.android') }}  {{ $t('append_field.ios') }}</div>
              </div>
            </div>
            <span class="cell-right"> <van-icon name="arrow"/> </span>
          </div>
        </van-cell>
        <van-cell @click="handleNavigation('h5')">
          <div slot="title">
            <div style="display: flex;align-items: center">
              <van-icon name="/static/images/icon/h5.svg" />
              <div class="text-content">
                <div class="text-title">{{ $t('append_field.app_name') }}</div>
                <div class="text-subtitle">{{ $t('append_field.info_publish') }} {{ $t('append_field.send_command') }} {{ $t('append_field.upload_material') }} </div>
              </div>
            </div>
            <span class="cell-right"> <van-icon name="arrow"/> </span>
          </div>
        </van-cell>
        <van-cell @click="handleNavigation('download')" v-if="type === ''">

          <div slot="title">
            <div style="display: flex;align-items: center">
              <van-icon name="/static/images/icon/download.svg" />
              <div class="text-content">
                <div class="text-title">{{ $t('append_field.video_tutorial') }}</div>
                <div class="text-subtitle">{{ $t('append_field.data_download') }} </div>
              </div>
            </div>
            <span class="cell-right"> <van-icon name="arrow"/> </span>
          </div>
        </van-cell>
      </van-cell-group>

    </div>

  </div>
</template>

<script>


import Cookies from "js-cookie";

// 常量定义
const SCREEN_CONTROL_TYPE = '100'; // 屏控apk类型
const SCREEN_CONTROL_APK_URL = 'https://appstore.esoncloud.com/#/appDetails?appId=83&access=aHPdCz7XRQY=';
const DEFAULT_APK_URL = 'https://appstore.esoncloud.com/#/appDownload';

export default {
  data() {
    return {
      language: '',
      channel: '',
      clientInfo: '',
      deviceName: '',
      type: '', // 100: 屏控apk，仅显示apk下载和助手
    }
  },
  computed: {
    /**
     * 路由配置映射
     */
    routeMap() {
      return {
        help: {
          url: '/Help',
          query: { lang: this.language }
        },
        apk: {
          url: DEFAULT_APK_URL,
          query: { lang: this.language, id: '63' }
        },
        h5: {
          url: '/login',
        },
        download: {
          url: '/myExplain',
          query: { type: 'phone' }
        }
      }
    },
    /**
     * 是否为屏控模式
     */
    isScreenControl() {
      return this.type == SCREEN_CONTROL_TYPE;
    }
  },
  mounted() {
    this.initLanguage();
    this.parseUrlParameters();
  },
  methods: {
    /**
     * 初始化语言设置
     */
    initLanguage() {
      let lang = (navigator.language || navigator.browserLanguage).toLowerCase();
      // 将 zh-cn, zh-tw 等转换为 zh
      if (lang.startsWith('zh-')) {
        lang = 'zh';
      }
      this.language = lang;
    },

    /**
     * 从URL中解析参数
     */
    parseUrlParameters() {
      try {
        const rawP = this.extractPParameter();
        
        if (rawP) {
          const dataObj = this.parsePParameter(rawP);
          this.assignDataFromObject(dataObj);
        } else {
          console.warn('未找到 p 参数');
        }
      } catch (error) {
        console.error('解析 p 参数失败:', error);
        console.error('当前 URL:', window.location.href);
      }
    },

    /**
     * 从URL hash中提取p参数
     * @returns {string|null} 原始p参数
     */
    extractPParameter() {
      const hash = window.location.hash;
      const hashQuery = hash.split('?')[1];
      const pMatch = hashQuery.match(/[&]?p=([^&]+)/);
      return pMatch ? pMatch[1] : null;
    },

    /**
     * 解析p参数
     * @param {string} rawP - 原始p参数
     * @returns {Object} 解析后的数据对象
     */
    parsePParameter(rawP) {
      // 使用 decodeURIComponent 解码，这样可以正确保留 + 号
      // decodeURIComponent 不会将 + 转换为空格，只有 URLSearchParams 和某些自动解码会
      const decodedP = decodeURIComponent(rawP);
      return JSON.parse(decodedP);
    },

    /**
     * 从解析的对象中赋值到组件数据
     * @param {Object} dataObj - 解析后的数据对象
     */
    assignDataFromObject(dataObj) {
      this.clientInfo = this.fixBase64String(dataObj.data);
      this.channel = dataObj.channel;
      this.deviceName = dataObj.name;
      this.type = dataObj.type || '';
    },

    /**
     * 修复base64字符串中的空格问题
     * @param {string} str - 可能包含空格的base64字符串
     * @returns {string} 修复后的字符串
     */
    fixBase64String(str) {
      if (typeof str === 'string' && str.includes(' ')) {
        const base64Pattern = /^[A-Za-z0-9+/= ]+$/;
        if (base64Pattern.test(str)) {
          return str.replace(/ /g, '+');
        }
      }
      return str;
    },

    /**
     * 统一处理页面跳转
     * @param {String} type - 跳转类型: 'help' 使用帮助, 'apk' APK下载, 'h5' H5助手下载, 'download' 视频教程
     */
    handleNavigation(type) {
      const route = this.routeMap[type];
      
      if (!route) {
        console.warn(`未知的跳转类型: ${type}`);
        return;
      }

      if (type === 'apk') {
        this.handleApkNavigation();
      } else {
        this.handleInternalNavigation(route);
      }
    },

    /**
     * 处理APK下载跳转
     */
    handleApkNavigation() {
      const targetUrl = this.isScreenControl ? SCREEN_CONTROL_APK_URL : this.buildUrlWithQuery(this.routeMap.apk);
      window.open(targetUrl, '_blank');
    },

    /**
     * 处理内部路由跳转
     * @param {Object} route - 路由配置对象
     */
    handleInternalNavigation(route) {
      this.saveCookies();
      this.$router.push({
        path: route.url,
        query: route.query,
      });
    },

    /**
     * 保存数据到cookies
     */
    saveCookies() {
      Cookies.set('clientInfo', this.clientInfo);
      Cookies.set('channel', this.channel);
      Cookies.set('deviceName', this.deviceName);
    },

    /**
     * 构建带查询参数的URL
     * @param {Object} route - 路由配置对象
     * @returns {string} 完整URL
     */
    buildUrlWithQuery(route) {
      let targetUrl = route.url;
      if (route.query) {
        const queryString = Object.keys(route.query)
          .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(route.query[key])}`)
          .join('&');
        const separator = targetUrl.includes('?') ? '&' : '?';
        targetUrl = `${targetUrl}${separator}${queryString}`;
      }
      return targetUrl;
    }
  },
}
</script>

<style lang="scss">
@import "../../public/static/css/app";

.scanredirect-page {
  .content {
    height: 100%;

    .topPic {
      height: 130px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      background: #006EFF;
      color: #fff;

      .van-image {
        border-radius: 50%;
        overflow: hidden;
      }
    }

    .dataWrap {
      background: #006EFF;
      color: #fff;
      height: 4rem;
      border-top: 1px solid #fff;

      .nut-col {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
        overflow: hidden;

        &:first-child {
          border-right: 1px solid #fff;
        }

        span {
          width: 100%;
          word-wrap: break-word;
          text-align: center;
          max-height: 40px;
          overflow: hidden;
        }
      }
    }

    .item-row {
      margin: 10px 0;
      background: #fff;

      .cell-right {
        float: right;
      }

      .van-icon {
        font-size: 18px;
        margin-right: 4px;
        img{
          width: 30px;
          height: 30px;
          margin-right: 10px;
        }
      }

      .van-empty{
        display: flex;
        align-items: flex-end;
        justify-content: center;
      }
      .text-content {
        flex: 1;
        display: flex;
        flex-direction: column;
      }

      .text-title {
        font-weight: 600; /* 加粗 */
        color: #323233;
        font-size: 16px;
        line-height: 1.5;
        margin-bottom: 2px;
      }

      .text-subtitle {
        font-weight: 400; /* 正常粗细 */
        color: #646566;
        font-size: 13px; /* 比标题小 */
        line-height: 1.4;
        opacity: 0.8; /* 稍微透明 */
      }
    }
    .van-cell{
      padding: 20px ;
    }
    .van-cell__title {
      & > div {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

    }

  }
  .addr{
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 180px;
  }
  .bigBtn {
    padding: 0 20px;

    .van-button--large {
      border-radius: 40px;
    }
  }
  .contact{
    .van-field__body{
      border-bottom: #131212 1px solid;
    }
    .van-field__label{
      width: 100%;
    }
    .van-cell{
      display: flex;
      flex-direction: column;
    }
  }
  .select-groupings{
    .van-cell{
      padding: 20px;
    }
    .language{
      height: 300px;
      overflow-y: auto;
    }
  }
  [class*=van-hairline]::after{
    border: none;
  }
}
</style>
